import { mergeQueryKeys } from "@lukemorales/query-key-factory";

import CategoriesApi from "./categories";
import CustomerRegistrationsApi from "./customer-registrations";
import MembersApi from "./members";
import RichMenuApi from "./richMenu";
import SystemSettingsApi from "./system-settings";
import AudienceApi from "./audiences";
import StampApi from "./stamp";
import InflowSourcesApi from "./inflow-sources";

export const masterRichMenuApi = new RichMenuApi();
export const categoriesApi = new CategoriesApi();
export const systemSettingsApi = new SystemSettingsApi();
export const audiencesApi = new AudienceApi();
export const stampApi = new StampApi();
export const inflowSourcesApi = new InflowSourcesApi();

export const membersApi = new MembersApi();
const customerRegistrationsApi = new CustomerRegistrationsApi();

export const queryKeys = mergeQueryKeys(
	customerRegistrationsApi.queryKeys,
	membersApi.queryKeys,
	audiencesApi.queryKeys,
	inflowSourcesApi.queryKeys,
);
